// Primero el paquete: material-table tiene dependencias circulares internas y cargar
// default-props antes que su index deja la app en blanco al arrancar.
import 'material-table'
import { defaultProps } from 'material-table/dist/default-props'
import MTPagination from '../components/atoms/mt-pagination'
import i18n from '../assets/i18n'

// Paginación de Velora para todas las tablas de material-table. MaterialTable mezcla en
// cada render sus defaultProps.components con los `components` de cada tabla, así que
// basta con registrarla aquí; una tabla que pase su propio Pagination lo sigue pisando.
defaultProps.components = { ...defaultProps.components, Pagination: MTPagination }

// Textos por defecto en el idioma de la app en lugar del inglés de material-table, para las
// tablas que no pasan `localization`. Getters y no una copia: el idioma se fija al iniciar
// sesión (i18n.setLanguage), después de cargar este módulo. Las tablas que sí pasan sus
// textos los siguen pisando, porque material-table mezcla cada sección con estos valores.
const originalLocalization = defaultProps.localization
const localizedSection = section => ({
  ...originalLocalization[section],
  ...((i18n.tableLocalization && i18n.tableLocalization[section]) || {})
})

defaultProps.localization = Object.keys(originalLocalization).reduce((localization, section) => {
  if (typeof originalLocalization[section] === 'object') {
    Object.defineProperty(localization, section, { enumerable: true, get: () => localizedSection(section) })
  } else {
    localization[section] = originalLocalization[section]
  }
  return localization
}, {})
